import { Stack, useTheme } from '@mui/material'
import React from 'react'
import { TabsTitle } from '../edit-address-settings-dialog.styles'

interface AddressTabsTitleProps {
  tabIndex: number
  handleChange: (event: React.SyntheticEvent, newValue: number) => void
}

const AddressTabsTitle = ({
  tabIndex,
  handleChange,
}: AddressTabsTitleProps) => {
  const theme = useTheme()

  return (
    <Stack direction="row" spacing={4} m={2}>
      <TabsTitle
        selected={tabIndex === 0}
        theme={theme}
        onClick={(event) => handleChange(event, 0)}
      >
        My Company
      </TabsTitle>
      <TabsTitle
        selected={tabIndex === 1}
        theme={theme}
        onClick={(event) => handleChange(event, 1)}
      >
        Address
      </TabsTitle>
    </Stack>
  )
}

export default AddressTabsTitle
